import { Tooltip } from '@joor/design-system'
import classNames from 'classnames'
import styled from 'styled-components'

import useRerenderOnSetLanguage from 'hooks/useRerenderOnSetLanguage'

import { FeatureCardIds } from 'features/Subscriptions/subscriptions.ids'

const StyledLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: var(--color-secondary-800) !important;
  cursor: pointer;
  pointer-events: auto;

  &:hover {
    color: var(--color-secondary-600) !important;
    text-decoration: underline;
  }

  svg circle {
    stroke: var(--color-secondary-800);
  }

  &.disabled-link {
    pointer-events: none;
    opacity: 0.6;
    cursor: not-allowed;

    &:hover {
      color: var(--color-secondary-800) !important;
      text-decoration: none;
    }
  }
`

const DisabledTooltipTrigger = styled.span`
  display: inline-block;
  cursor: not-allowed;
`

const StyledTooltip = styled(Tooltip)`
  cursor: not-allowed;
`

const SUBSCRIPTION_OWNER_TOOLTIP =
  'Only the subscription owner can manage this subscription'

type CompProps = {
  onClick?: () => void
  disabled?: boolean
  text?: string
}

export const ManageBillingAndSubsLink = ({
  onClick = () => {},
  disabled = false,
  text = 'Manage Billing & Subscription',
}: CompProps) => {
  useRerenderOnSetLanguage()

  return disabled ? (
    <StyledTooltip content={SUBSCRIPTION_OWNER_TOOLTIP}>
      <DisabledTooltipTrigger>
        <StyledLink
          as="span"
          aria-disabled="true"
          className={classNames(
            'disabled-link',
            FeatureCardIds.ManageBillingLink,
          )}
          onClick={() => {}}
        >
          {window?.Localize?.translate?.(text)}
        </StyledLink>
      </DisabledTooltipTrigger>
    </StyledTooltip>
  ) : (
    <StyledLink
      as="span"
      className={FeatureCardIds.ManageBillingLink}
      onClick={() => onClick()}
    >
      {window?.Localize?.translate?.(text)}
    </StyledLink>
  )
}
